import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { IEntityFilter } from './IEntityFilter';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EntityFilterService {
  uri = `${environment.apiLocation}/EntityFilter/?FilterEntity=`;
  constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(LoggingService) private log: LoggingService
    ) {}
    loadEntityFilter(filterType: string): Observable<Array<IEntityFilter>> {
      return this.http
      .get<Array<IEntityFilter>>(`${this.uri}${filterType}`)
      .pipe(
          tap(res =>
              this.log.verbose({
                  type: 'DirectReportsLookupService:reponse',
                  res
              })
          )
      );
    }
}
